$(function () {

    $('input[name="phone"]').inputmask('099999999');

    let url = $(location).attr('href').split("/").splice(0, 5).join("/");
    let segments = url.split( '/' );
    let lang = segments[3];
    let two_segment = segments[4];
    if(lang=='') {lang = 'ro';}

    $('.slick__slider-top').slick({
        accessibility: true,
        dots: true,
        prevArrow: '<button class="slick__slider-left slick__slider__btn"><img src="/dist/img/arow_left.svg" alt="left"></button>',
        nextArrow: '<button class="slick__slider-right slick__slider__btn"><img src="/dist/img/arow_right.svg" alt="right"></button>',
        dotsClass: "slider1",
        responsive: [
            {
                breakpoint: 1480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    centerMode: false,
                    dots: true
                }
            },
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 1,
                    arrows:false,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    arrows:false,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots:true,
                    arrows:false,
                }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        ]
    });

    $('.slick__slider-red').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: true,
        centerMode: true,
        focusOnSelect: true,
        centerPadding: '0',
        variableWidth: true,
        infinite: true,
        dotsClass: "slider_red",
        prevArrow: '<button class="slick__slider-left slick__slider__btn"><img src="/dist/img/arow_left.svg" alt="left"></button>',
        nextArrow: '<button class="slick__slider-right slick__slider__btn"><img src="/dist/img/arow_right.svg" alt="right"></button>',
        responsive: [
            {
                breakpoint: 1600,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    centerPadding: '0',
                    infinite: true,
                    centerMode: true,
                    variableWidth: true,
                    dots: true
                }
            },
            {
                breakpoint: 1479,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                    centerMode: true,
                    variableWidth: true,
                    dots: true
                }
            },
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    arrows: false,
                    adaptiveHeight: true,
                    dots: true
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 3,
                    arrows:false,
                    slidesToScroll: 1,
                    adaptiveHeight: true,
                    centerMode: true,
                    centerPadding: "0",
                    variableWidth: true,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                    arrows:false,
                    centerMode: false,
                    slidesToScroll: 1,
                    centerMode: true,
                    centerPadding: "0",
                    variableWidth: true,
                }
            },
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots:true,
                    arrows:false,
                    centerMode: true,
                    centerPadding: "0",
                    variableWidth: true,
                }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        ]
    });

    $('.piatra__slider').slick({
        accessibility: true,
        infinite: true,
        slidesToShow: 4,
        centerMode: false,
        centerPadding: "10px",
        slidesToScroll: 1,
        AdaptiveHeight: true,
        variableWidth: true,
        dots: true,
        dotsClass: "slider3",
        prevArrow: '<button class="slick__slider-left3 slick__slider__btn3"><svg xmlns="http://www.w3.org/2000/svg" width="11" height="18" viewBox="0 0 11 18"><g><g><path d="M3.418 8.997l7.293 7.293-1.414 1.414L.59 8.997 9.297.29l1.414 1.414z"/></g></g></svg></button>',
        nextArrow: '<button class="slick__slider-right3 slick__slider__btn3"><svg xmlns="http://www.w3.org/2000/svg" width="11" height="18" viewBox="0 0 11 18"><g><g><path d="M7.586 9L.293 16.293l1.414 1.414L10.414 9 1.707.293.293 1.707z"/></g></g></svg></button>',
        responsive: [
            {
                breakpoint: 1480,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 1,
                    infinite: true,
                    centerMode: false,
                    dots: true
                }
            },
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 1,
                    arrows: false,
                    adaptiveHeight: true,
                    variableWidth: true,
                    centerMode: true,
                    infinite:true,
                    centerPadding:"0"
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 3,
                    arrows:false,
                    infinite: true,
                    slidesToScroll: 1,
                    centerMode: false,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                    arrows:false,
                    centerMode: true,
                    centerPadding: "39px",
                    infinite: true,
                    // slidesToScroll: 1
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots:true,
                    arrows:false,
                    centerMode: false,
                    centerPadding: "100%",
                    mobileFirst: true,
                    adaptiveHeight: true,
                    infinite: false,
                }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        ]
    });

    $('.slider__third').slick({
        accessibility: true,
        infinite: false,
        slidesToShow: 5,
        AdaptiveHeight: true,
        dots: true,
        dotsClass: "slider3",
        prevArrow: '<button class="slick__slider-left slick__slider__btn slick__slider-left4 slick__slider__btn4"><svg xmlns="http://www.w3.org/2000/svg" width="11" height="18" viewBox="0 0 11 18"><g><g><path d="M3.418 8.997l7.293 7.293-1.414 1.414L.59 8.997 9.297.29l1.414 1.414z"/></g></g></svg></button>',
        nextArrow: '<button class="slick__slider-right slick__slider__btn slick__slider-right4 slick__slider__btn4"><svg xmlns="http://www.w3.org/2000/svg" width="11" height="18" viewBox="0 0 11 18"><g><g><path d="M7.586 9L.293 16.293l1.414 1.414L10.414 9 1.707.293.293 1.707z"/></g></g></svg></button>',
        responsive: [
            {
                breakpoint: 1600,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 1,
                    infinite: true,
                    centerMode: false,
                    arrows:true,
                    adaptiveHeight: true,
                    dots: true
                }
            },
            {
                breakpoint: 1479,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 1,
                    infinite: true,
                    centerMode: false,
                    arrows:false,
                    adaptiveHeight: true,
                    variableWidth: true,
                    dots: true
                }
            },
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 1,
                    arrows: false,
                    adaptiveHeight: true,
                    variableWidth: true,
                    centerMode: true,
                    infinite:true
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 3,
                    arrows:false,
                    infinite: true,
                    centerPadding: "0",
                    slidesToScroll: 1,
                    variableWidth: true,
                    centerMode: true
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 3,
                    arrows:false,
                    centerMode: true,
                    centerPadding: "30px",
                    variableWidth: true,
                    infinite: true,
                    // slidesToScroll: 1
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    dots:true,
                    arrows:false,
                    // centerMode: false,
                    // centerPadding: "100%",
                    mobileFirst: true,
                    adaptiveHeight: true,
                    variableWidth: true,
                    infinite: true,
                }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        ]
    });

    $('.descopera__slider').slick({
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        infinite: true,
        focusOnSelect: false,
        dotsClass: "descopera__dots",
        responsive: [
            {
                breakpoint: 1440,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    centerMode: false,
                    dots: true
                }
            },
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 1,
                    arrows:false,
                    centerMode: false,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    arrows:false,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        ]
    });

    $('.sec6__slider').slick({
        dots: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        infinite: false,
        focusOnSelect: false,
        centerMode: false,
        dotsClass: "slider6",
        responsive: [
            {
                breakpoint: 1440,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                    centerMode: false,
                    dots: true
                }
            },
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 3,
                    adaptiveHeight: true,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 3,
                    arrows:false,
                    centerMode: false,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    arrows:false,
                    centerMode: true,
                    centerPadding: "30px",
                    variableWidth: true,
                    infinite: true,
                    // slidesToScroll: 1
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots:true,
                    arrows:false,
                    // centerMode: false,
                    // centerPadding: "100%",
                    mobileFirst: true,
                    adaptiveHeight: true,
                    // variableWidth: true,
                    infinite: true,
                }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        ]
    });

    $('.marmura__slider').slick({
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        asNavFor: '.marmura__slider-nav',
        infinite:true,
        prevArrow: '<button class="slick__slider-left3 slick__slider__btn3 marmura__slider-btn marmura__slider-btn-left"><svg xmlns="http://www.w3.org/2000/svg" width="11" height="18" viewBox="0 0 11 18"><g><g><path d="M3.418 8.997l7.293 7.293-1.414 1.414L.59 8.997 9.297.29l1.414 1.414z"/></g></g></svg></button>',
        nextArrow: '<button class="slick__slider-right3 slick__slider__btn3 marmura__slider-btn marmura__slider-btn-right"><svg xmlns="http://www.w3.org/2000/svg" width="11" height="18" viewBox="0 0 11 18"><g><g><path d="M7.586 9L.293 16.293l1.414 1.414L10.414 9 1.707.293.293 1.707z"/></g></g></svg></button>',
        responsive: [
            {
                breakpoint: 1440,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    centerMode: false,
                    dots: false
                }
            },
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 1,
                    arrows:true,
                    centerMode: false,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    arrows:false,
                    dots: true,
                    adaptiveHeight:true,
                    dotsClass: "slider3",
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    adaptiveHeight:true,
                    arrows: false,
                    dotsClass: "slider3",
                    dots: true
                }
            }

        ]
    });

    $('.marmura__slider-nav').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        asNavFor: '.marmura__slider',
        dots:false,
        centerMode: false,
        focusOnSelect: false,
        arrows: false,
        infinite:true,
        responsive: [
            {
                breakpoint: 1440,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    infinite: true,
                    centerMode: false,
                    dots: false
                }
            },
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 4,
                    arrows:false,
                    centerMode: false,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 578,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        ]
    });

    $(".hamburger").click(function(event) {
        $(".hamburger").toggleClass('hamburger__active'),
            $(".mobile__menu").toggleClass('mobile__menu__active')
    });

    $('.form__btn').on('click', function(e){
        e.preventDefault();
        $('.form__btn').removeClass('form__btn--active');

        $(this).addClass('form__btn--active');
    });

    var acc = document.getElementsByClassName("accordion");
    var i;

    for (i = 0; i < acc.length; i++) {
        acc[i].addEventListener("click", function () {
            this.classList.toggle("active");
            var panel = this.nextElementSibling;
            if (panel.style.maxHeight) {
                panel.style.maxHeight = null;
            } else {
                panel.style.maxHeight = panel.scrollHeight + "px";
            }
        });
    }

    $(".polzunok-container-5 input").change(function () {
        var input_left = $(".polzunok-input-5-left").val().replace(/[^0-9]/g, ''),
            opt_left = $(".polzunok-5").slider("option", "min"),
            where_right = $(".polzunok-5").slider("values", 1),
            input_right = $(".polzunok-input-5-right").val().replace(/[^0-9]/g, ''),
            opt_right = $(".polzunok-5").slider("option", "max"),
            where_left = $(".polzunok-5").slider("values", 0);
        if (input_left > where_right) {
            input_left = where_right;
        }
        if (input_left < opt_left) {
            input_left = opt_left;
        }
        if (input_left == "") {
            input_left = 0;
        }
        if (input_right < where_left) {
            input_right = where_left;
        }
        if (input_right > opt_right) {
            input_right = opt_right;
        }
        if (input_right == "") {
            input_right = 0;
        }
        $(".polzunok-input-5-left").val(input_left);
        $(".polzunok-input-5-right").val(input_right);
        if (input_left != where_left) {
            $(".polzunok-5").slider("values", 0, input_left);
        }
        if (input_right != where_right) {
            $(".polzunok-5").slider("values", 1, input_right);
        }
    });

    $(document).on('click', '.add_to_cart', function(event){

        event.preventDefault();

        self = $(this);
        let id = self.data('id');
        let qty = $(".qty").val();
        console.log(qty);
        if(qty==='') qty = 1;
        if(id!=='') {
            $.ajax({
                type: "POST",
                url: "/"+lang+"/add_to_cart",
                data: {
                    'id': id,
                    'qty': qty,
                },
                dataType: 'json',
                success: function(result) {
                    $('.mini-popup-content').html(result.msg);
                    $('.mini-popup').fadeIn(500).css('display', 'flex');
                    $('.basket_span span').html(result.total_qty);
                    setTimeout(function(){
                        $('.mini-popup').css('display', 'none');
                    }, 1500);
                },
                error: function(result){
                    console.log(result);
                }
            });
        }
    });

    $(document).on('change', 'input[name="qty"]', function(event){

        let key = $(this).data('key');
        let qty = $(this).val();
        let row = $(this).closest(".cosul__card-wrapp");

        if(key!=='') {
            $.ajax({
                type: "POST",
                url: "/"+lang+"/change_to_cart",
                data: {
                    'key': key,
                    'qty': qty,
                },
                dataType: 'json',
                success: function(result) {
                    row.find('.item_result').html(result.item_sum);
                    $('.total_sum').html(result.total_sum);
                    $('.basket_span span').html(result.total_qty);
                },
                error: function(result){
                    console.log(result);
                }
            });
        }
        event.preventDefault();
    });
});